import React, { useState, useEffect } from "react";
import axios from "axios";
import Pagination from "../components/Pagination";
import ProductCard from "../components/ProductCard";
import SearchBar from "../components/SearchBar";

const API_BASE_URL = "https://nzpdp-traceability-system-production-c63a.up.railway.app";

const ViewProducts = () => {
  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 3; 

  useEffect(() => {
    console.log("[ViewProducts] useEffect => fetching products...");
    axios
      .get(`${API_BASE_URL}/api/admin/products`)
      .then((response) => {
        console.log("[ViewProducts] Fetched products:", response.data);
        setProducts(response.data);
      })
      .catch((error) => {
        console.error(
          "[ViewProducts] Error fetching products:",
          error.response?.status,
          error.response?.data || error.message
        );
      });
  }, []);

 
  const filteredProducts = products.filter((product) =>
    product.product_code.toLowerCase().includes(searchTerm.toLowerCase())
  );

  console.log(`[ViewProducts] Filtering products by "${searchTerm}" => Found ${filteredProducts.length} matches.`);


  const sortedProducts = [...filteredProducts].sort((a, b) => {
    return b.is_traceable - a.is_traceable;
  });


  const totalPages = Math.ceil(sortedProducts.length / productsPerPage);
  const startIndex = (currentPage - 1) * productsPerPage;
  const currentProducts = sortedProducts.slice(startIndex, startIndex + productsPerPage);

  console.log(
    `[ViewProducts] Pagination => currentPage: ${currentPage}, totalPages: ${totalPages}, displaying indices [${startIndex}, ${startIndex + productsPerPage - 1}]`
  );

 
  const handleDelete = (deletedProductCode) => {
    console.log(`[ViewProducts] handleDelete => Deleting product_code: ${deletedProductCode}`);
    setProducts((prevProducts) => prevProducts.filter((p) => p.product_code !== deletedProductCode));
  };

 
  const handleActivate = (productCode) => {
    console.log(`[ViewProducts] Activating product: ${productCode}`);

    axios
      .put(`${API_BASE_URL}/api/admin/products/activate/${productCode}`)
      .then(() => {
        console.log(`[ViewProducts] Product activated: ${productCode}`);
        setProducts((prevProducts) =>
          prevProducts.map((p) =>
            p.product_code === productCode ? { ...p, is_traceable: 1 } : p
          )
        );
      })
      .catch((error) => {
        console.error(
          `[ViewProducts] Error activating product: ${productCode}`,
          error.response?.status,
          error.response?.data || error.message
        );
      });
  };

  return (
    <div>
      <h3>Existing Products</h3>
      <div className="admin-form">
        <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} placeholder="Search by Product Code" />
        <div className="batch-list">
          {currentProducts.length > 0 ? (
            currentProducts.map((product, index) => (
              <ProductCard key={index} product={product} onDelete={handleDelete} onActivate={handleActivate} />
            ))
          ) : (
            <p className="no-batches">No matching products found.</p>
          )}
        </div>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={(page) => {
            console.log(`[ViewProducts] Changing to page: ${page}`);
            setCurrentPage(page);
          }}
        />
      </div>
    </div>
  );
};

export default ViewProducts;
